import { render, staticRenderFns } from "./setting-profile.html?vue&type=template&id=51335424&scoped=true&"
import script from "./setting-profile.js?vue&type=script&lang=js&"
export * from "./setting-profile.js?vue&type=script&lang=js&"
import style0 from "./setting-profile.scss?vue&type=style&index=0&id=51335424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51335424",
  null
  
)

export default component.exports